export default __webpack_public_path__ + "static/date-12fda4dfcd1209055f7d83c5d85a69e0.svg";